export const colorPrimitives = {
  'gray-100': '#F5F6F8',
  'gray-200': '#EAEBF2',
  'gray-300': '#C4CBD5',
  'gray-400': '#B0B3B9',
  'gray-500': '#8C93A0',
  'gray-600': '#757D8D',
  'gray-700': '#484D58',
  'gray-800': '#313338',
  'gray-900': '#202124',
  'gray-1000': '#17181B',

  'pink-100': '#FCEBFF',
  'pink-200': '#FBE8FF',
  'pink-300': '#F3AEFF',
  'pink-400': '#CF59E2',
  'pink-500': '#D548EC',
  'pink-600': '#C742DD',
  'pink-700': '#AA30BE',
  'pink-800': '#7B0090',
  'pink-900': '#570066',
  'pink-1000': '#35003F',

  'blue-100': '#E8F2FF',
  'blue-200': '#D1E4FF',
  'blue-300': '#A2C9FF',
  'blue-400': '#73ADFF',
  'blue-500': '#4090FF',
  'blue-600': '#076EFF',
  'blue-700': '#0056D0',
  'blue-800': '#00419D',
  'blue-900': '#002D6D',
  'blue-1000': '#001A40',

  'green-100': '#D8F7F0',
  'green-200': '#AFEFE1',
  'green-300': '#51DCBD',
  'green-400': '#00C296',
  'green-500': '#00A47F',
  'green-600': '#008769',
  'green-700': '#006B53',
  'green-800': '#00513F',
  'green-900': '#00382B',
  'green-1000': '#002019',

  'red-100': '#FFECEC',
  'red-200': '#FFD9D9',
  'red-300': '#FFB1B1',
  'red-400': '#FF8585',
  'red-500': '#FF4E4E',
  'red-600': '#F11F1F',
  'red-700': '#D43B3B',
  'red-800': '#A40A0A',
  'red-900': '#670000',
  'red-1000': '#400000',

  'yellow-100': '#FFF0CB',
  'yellow-200': '#FFDF93',
  'yellow-300': '#FFBB16',
  'yellow-400': '#E99B00',
  'yellow-500': '#C77100',
  'yellow-600': '#A85A00',
  'yellow-700': '#8A4900',
  'yellow-800': '#663600',
  'yellow-900': '#472600',
  'yellow-1000': '#291500',

  'white-10': 'rgba(255,255,255,0.1)',
  'white-20': 'rgba(255,255,255,0.2)',
  'white-30': 'rgba(255,255,255,0.3)',
  'white-40': 'rgba(255,255,255,0.4)',
  'white-50': 'rgba(255,255,255,0.5)',
  'white-60': 'rgba(255,255,255,0.6)',
  'white-70': 'rgba(255,255,255,0.7)',
  'white-80': 'rgba(255,255,255,0.8)',
  'white-90': 'rgba(255,255,255,0.9)',
  'white-100': 'rgba(255,255,255,1)',

  'black-10': 'rgba(0,0,0,0.1)',
  'black-20': 'rgba(0,0,0,0.2)',
  'black-30': 'rgba(0,0,0,0.3)',
  'black-40': 'rgba(0,0,0,0.4)',
  'black-50': 'rgba(0,0,0,0.5)',
  'black-60': 'rgba(0,0,0,0.6)',
  'black-70': 'rgba(0,0,0,0.7)',
  'black-80': 'rgba(0,0,0,0.8)',
  'black-90': 'rgba(0,0,0,0.9)',
  'black-100': 'rgba(0,0,0,1)',

  transparent: 'transparent',
};
